import React from 'react';
import { Tab, Tabs as ReactTabs, TabPanel, TabList } from 'react-tabs';
import { Container } from 'components/container/Container';
// import 'react-tabs/style/react-tabs.css';

//  same styling as page-filter
import s from 'components/page-filter/PageFilter.scss';

export interface ITabs {
  title: string;
  content: React.ReactElement<any>;
}

interface IProps {
  title?: string;
  tabs: ITabs[];
  container?: boolean;
}

export const Tabs = ({ title, tabs, container = false }: IProps) => {
  const ContainerElement = container ? Container : 'div';

  return (
    <div className={s.pageFilter} style={{ backgroundColor: 'transparent' }}>
      <ReactTabs>
        <ContainerElement>
          <div className={s.pageFilter__inner}>
            <h1 className={s.pageFilter__heading}>{title}</h1>
            <TabList className={s.pageFilter__list}>
              {tabs.map(({ title: tabTitle }, i) => (
                <Tab className={s.pageFilter__item} selectedClassName={s.active} key={i}>
                  {tabTitle}
                </Tab>
              ))}
            </TabList>
          </div>

          <div className={s.pageFilter__content}>
            {tabs.map(({ content }, i) => (
              <TabPanel key={i}>{content}</TabPanel>
            ))}
          </div>
        </ContainerElement>
      </ReactTabs>
    </div>
  );
};
